// extracted by mini-css-extract-plugin
var _1 = "MultiValuedList-moduleMultiValuedList__ZJwbV";
var _2 = "MultiValuedList-moduleMultiValuedListItems__mzDL2";
var _3 = "MultiValuedList-modulelarge__KZhHy";
var _4 = "MultiValuedList-modulemeasurement__WA3yS";
var _5 = "MultiValuedList-modulemedium__vPLk7";
var _6 = "MultiValuedList-moduleresponsive__JRJPs";
var _7 = "MultiValuedList-modulesmall__jSNQn";
var _8 = "MultiValuedList-modulex-large__gNKYE";
var _9 = "MultiValuedList-modulex-small__R0y9Z";
export { _1 as "MultiValuedList", _2 as "MultiValuedListItems", _3 as "large", _4 as "measurement", _5 as "medium", _6 as "responsive", _7 as "small", _8 as "x-large", _9 as "x-small" }
